// extracted by mini-css-extract-plugin
export default {"reply":"ReplyForm_reply__Dicv0","reply_btn":"ReplyForm_reply_btn__wTrcm"};